import _ from 'lodash';

export const isEquivalent = (array1, array2) => {
  if (!_.isArray(array1) || !_.isArray(array2)) {
    return false;
  }
  if (array1.length !== array2.length) {
    return false;
  }
  for (let i = 0; i < array1.length; i += 1) {
    let exists = false;
    for (let j = 0; j < array2.length; j += 1) {
      if (_.isEqual(array1[i], array2[j])) {
        exists = true;
      }
    }
    if (!exists) {
      return false;
    }
  }

  return true;
};

export default { isEquivalent };
